import {
  Controller
} from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal"]
  connect() {
    this.element.dataset.action = "modal#show";
  }

  show(event) {
    const dialog = document.getElementById(event.params.dialog);
    dialog.showModal();
  }


  open(event) {
    event.preventDefault();

    this.modalTarget.showModal();
  }

  close(event) {
    event.preventDefault();

    this.modalTarget.close();
  }
}
